import { render, staticRenderFns } from "./ContentChain.vue?vue&type=template&id=0ee30421&"
import script from "./ContentChain.vue?vue&type=script&lang=js&"
export * from "./ContentChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports